import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  code: string;
}

const PerformanceBadge: React.FC<Props> = ({ code }) => {
  const performanceValues: { [key: string]: string } = {
    Satisfactory: 'S',
    'Partially Satisfactory': 'PS',
    Unsatisfactory: 'U',
    'Partially Unsatisfactory': 'PU',
  };

  const icon =
    code === 'Satisfactory' || code === 'Partially Satisfactory'
      ? 'arrow-circle-up'
      : 'arrow-circle-down';

  return (
    <div className="badge-base">
      <div className="badge-icon">
        <FontAwesomeIcon icon={icon} className={`performance-svg ${performanceValues[code]}`} />
      </div>
      <div className="badge-text">
        <span>{performanceValues[code]}</span>
      </div>
    </div>
  );
};

export default React.memo(PerformanceBadge);
